export default "__VITE_ASSET__PJLNHSQ2__"